import { module } from 'stereomodularjs';

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {
		this.closestVideo = this.el.closest('section').querySelector('video');
		this.pauseTexte = this.el.getAttribute('data-pause-text');
		this.playTexte = this.el.getAttribute('data-play-text');
		this.text = this.el.querySelector('.c-fold__media__control__text');
		this.text.innerHTML = this.pauseTexte;
		this.el.setAttribute('aria-label', this.pauseTexte);
		
		this.el.addEventListener('click', () => {
			this.el.classList.toggle('is-active');
			if (this.el.classList.contains('is-active')) {
				this.closestVideo.pause();
				this.text.innerHTML = this.playTexte;
				this.el.setAttribute('aria-label', this.playTexte);
			} else {
				this.closestVideo.play();
				this.text.innerHTML = this.pauseTexte;
				this.el.setAttribute('aria-label', this.pauseTexte);
			}
		});
	}
}
